<template>
  <Modal @close="$emit('close-modal')">
    <BoxForm
      :messageError="messageError"
      @clena-error="messageError = !messageError"
      :loading="loading"
    >
      <template v-slot:header>
        <span>{{ is_pt_br ? "Editar Bloco" : "Edit Block" }}</span>
        <!-- <button class="btn header" @click="$emit('close')">
          <i class="icon icon-close"></i>
        </button> -->
      </template>

      <template>
        <div class="row">
          <div class="form-group p-1 col-7 d-flex flex-column">
            <input
              v-model="stone.name_material"
              type="text"
              class="form-control"
              :placeholder="is_pt_br ? 'Nome do material' : 'Material name'"
            />
            <small class="text-muted">{{
              is_pt_br ? "Nome do material" : "Material name"
            }}</small>
          </div>
          <div class="form-group p-1 col-5">
            <input
              v-model="stone.bloc_number"
              type="number"
              class="form-control"
              placeholder="N°"
            />
            <small class="text-muted">N°</small>
          </div>
        </div>
        <div class="row ">
          <div class="form-group p-1 col-12 d-flex flex-column">
            <select
              name=""
              id=""
              v-model="stone.type"
              class="form-control rounded"
            >
              <option v-for="(item, i) in stone_types" :key="i" :value="item">
                {{ item }}
              </option>
            </select>
            <small class="text-muted">Tipo</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group p-1 col-6 flex-column d-flex">
            <input
              type="number"
              class="form-control"
              v-model="stone.width"
              :placeholder="is_pt_br ? 'Largura' : 'Width'"
            />
            <small class="text-muted"
              >{{ is_pt_br ? "Largura" : "Width" }} (m)</small
            >
          </div>
          <div class="form-group p-1 col-6 flex-column d-flex">
            <input
              type="number"
              class="form-control"
              v-model="stone.height"
              :placeholder="is_pt_br ? 'Altura' : 'Heigth'"
            />
            <small class="text-muted"
              >{{ is_pt_br ? "Altura" : "Heigth" }} (m)</small
            >
          </div>
          <div class="form-group p-1 col-6 flex-column d-flex">
            <input
              type="number"
              class="form-control"
              v-model="stone.diameter"
              :placeholder="is_pt_br ? 'Comprimento' : 'Diameter'"
            />
            <small class="text-muted"
              >{{ is_pt_br ? "Comprimento" : "Diameter" }}(m)</small
            >
          </div>
          <div class="form-group p-1 col-6 flex-column d-flex">
            <input
              type="number"
              class="form-control"
              v-model="stone.weight"
              :placeholder="is_pt_br ? 'Peso' : 'Weight'"
            />
            <small class="text-muted"
              >{{ is_pt_br ? "Peso" : "Weight" }} (Ton)</small
            >
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="row mt-3 p-0">
          <div class="col-12 d-flex p-0 justify-content-end">
            <button
              class="btn btn-outline-dark"
              @click.prevent="handleEditeStone()"
            >
              {{ is_pt_br ? "Editar" : "Edite" }}
            </button>
          </div>
        </div>
      </template>
    </BoxForm>
  </Modal>
</template>

<script>
import Modal from "../utils/Modal.vue";
import BoxForm from "../utils/BoxForm.vue";
import { mapActions } from "vuex";
export default {
  name: "EditeStone",
  components: { Modal, BoxForm },
  props: {
    stone: Object,
  },
  data() {
    return {
      messageError: "",
      loading: false,
      stone_types: [
        "Granito",
        "Mármore",
        "Quartzito",
        "Cristal",
        "Feldspato",
        "Xisto",
      ],
    };
  },
  computed: {
    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  methods: {
    ...mapActions("stone", ["editeStone", "setStoneDetail"]),

    async handleEditeStone() {
      this.loading = true;
      await this.editeStone(this.stone)
        .then((res) => {
          this.setStoneDetail(this.stone.id);
          this.$emit("close-modal", null);
        })
        .catch((error) => {
          console.error("erro na edição de blocos");
          this.messageError = error;
          // this.$emit("edited", error);
        });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  height: 18px;
  width: 18px;
}
</style>
